import { Easing, WithTimingConfig } from "react-native-reanimated";
import { verticalScale_ } from "../../../Universal/API/Scale";

export interface handleExpandedMenu{
    open: (callBack?: any) => any,
    close: (callBack?: any) => any,
    openClose: (props?: any) => any,
    setGuts: (props: any) => any,   
}

export const config = {
    EXPANDED_HEIGHT: verticalScale_(300),
    HIDDEN_HEIGHT: 0,
    expandConfig: {
        duration: 400,
        easing: Easing.ease
    } as WithTimingConfig,
    closeConfig: {
        duration: 400,
        easing: Easing.ease
    } as WithTimingConfig
}


export const TOP_NAV_COLOR = '#F9F9F9'


export const copyEvent = async ({
    text, onSuccess
}) => {
    
    if (!text) return;

    try {
        // Modern browsers
        await navigator.clipboard.writeText(text);
        console.log('Copied:', text);
        if(onSuccess){
            onSuccess()
        }
    } catch (e) {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }
};
